import { usePageAnalytics } from '../hooks/usePageAnalytics';

/**
 * Invisible tracker component — fires a pageview beacon on every route change.
 * Must render inside <BrowserRouter> so usePageAnalytics can read useLocation.
 */
export const AnalyticsTracker = () => {
  usePageAnalytics();
  return null;
};
